module.exports = __webpack_public_path__ + "static/media/bg_002.fb066f59.jpeg";